export default "__VITE_ASSET__DVf0evCU__"